/*
 *
 * Account reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_OPTIONS_WATCHER,
  GET_OPTIONS_SUCCESS,
  GET_OPTIONS_FAILED,
  PUT_INFO_COMPANY_WATCHER,
  GET_INFO_COMPANY_WATCHER,
  GET_INFO_COMPANY_SUCCESS,
  GET_INFO_COMPANY_FAILED,
} from "./constants"

export const initialState = fromJS({
  optionsSelect: {},
  isLoadingOptionsSelect: true,
  infoCompany: {},
  isLoadingInfoCompany: true,
})

function accountReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INFO_COMPANY_WATCHER:
    case PUT_INFO_COMPANY_WATCHER:
      return (
        state
          // .set('infoCompany', {})
          .set("isLoadingInfoCompany", true)
      )
    case GET_INFO_COMPANY_SUCCESS:
      return state
        .set("infoCompany", action.payload)
        .set("isLoadingInfoCompany", false)
    case GET_INFO_COMPANY_FAILED:
      return (
        state
          // .set('infoCompany', {})
          .set("isLoadingInfoCompany", false)
      )

    case GET_OPTIONS_WATCHER:
      return state.set("optionsSelect", {}).set("isLoadingOptionsSelect", true)
    case GET_OPTIONS_SUCCESS:
      return state
        .set("optionsSelect", action.payload)
        .set("isLoadingOptionsSelect", false)
    case GET_OPTIONS_FAILED:
      return state.set("optionsSelect", {}).set("isLoadingOptionsSelect", false)

    default:
      return state
  }
}

export default accountReducer
